module.exports = __webpack_public_path__ + "static/media/ndi-product-image.b27ee75d.jpg";